module.exports = __WEBPACK_EXTERNAL_MODULE_single_spa__;